// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Registration Page */

.loading-state {
  text-align: center;
  margin-top: 120px;
  color: #b3b3b3;
}

.closed-icon {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
  color: #ff6b35;
}

.registration-page {
  color: #f4f4f4;
}

.registration-hero {
  text-align: center;
  margin-top: 96px;
  margin-bottom: 24px;
}

.registration-hero h1 {
  font-family: Eczar, serif;
  font-size: 48px;
  line-height: 1.2;
  margin-bottom: 12px;
}

.registration-hero .accent {
  color: #ff6b35;
}

.registration-hero p {
  color: #b3b3b3;
  max-width: 820px;
  margin: 8px auto 0;
  line-height: 32px;
}

.registration-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 18px;
}

.reg-card {
  background: linear-gradient(0deg, #1c1b26, #1c1b26),
    linear-gradient(180deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0) 100%);
  border: 3px solid rgba(75, 75, 75, 0.25);
  border-radius: 16px;
  padding: 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: transform 0.2s ease, box-shadow 0.25s ease, border-color 0.25s ease;
}

.reg-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 30px rgba(251, 133, 0, 0.15);
  border-color: rgba(251, 133, 0, 0.35);
}

.reg-card__head h2 {
  font-family: Eczar, serif;
  font-size: 24px;
  margin-bottom: 4px;
}

.reg-card__head p {
  color: #b3b3b3;
  line-height: 28px;
}

.reg-card__list {
  margin: 10px 0 12px;
  padding-left: 18px;
  color: #d6d6d6;
}

.reg-card__list li {
  margin: 6px 0;
}

.reg-card__cta {
  margin-top: 8px;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-decoration: none;
  color: #0b0b0f;
  font-weight: 600;
  font-family: Inter, sans-serif;
  border-radius: 14px;
  min-height: 48px;
  padding: 0 18px;
}

.btn--primary {
  background: linear-gradient(90deg, #ff6b35, #fb8500);
  box-shadow: 0 10px 24px rgba(251, 133, 0, 0.25);
  transition: transform 0.15s ease, box-shadow 0.2s ease, filter 0.2s ease;
}

.btn--primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 30px rgba(251, 133, 0, 0.35);
  filter: saturate(1.05);
}

.btn--primary:active {
  transform: translateY(0);
  box-shadow: 0 6px 14px rgba(251, 133, 0, 0.25);
}

.btn__icon {
  font-size: 18px;
}

.registration-note {
  margin-top: 18px;
  text-align: center;
}

.registration-note p {
  color: #9f9f9f;
}

/* Responsiveness */
@media screen and (max-width: 768px) {
  .registration-hero h1 {
    font-size: 36px;
  }
}

@media screen and (max-width: 576px) {
  .registration-hero {
    margin-top: 84px;
  }
  .registration-hero h1 {
    font-size: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Registration.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE;sFACoF;EACpF,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,+EAA+E;AACjF;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oDAAoD;EACpD,+CAA+C;EAC/C,wEAAwE;AAC1E;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Registration Page */\n\n.loading-state {\n  text-align: center;\n  margin-top: 120px;\n  color: #b3b3b3;\n}\n\n.closed-icon {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 24px;\n  color: #ff6b35;\n}\n\n.registration-page {\n  color: #f4f4f4;\n}\n\n.registration-hero {\n  text-align: center;\n  margin-top: 96px;\n  margin-bottom: 24px;\n}\n\n.registration-hero h1 {\n  font-family: Eczar, serif;\n  font-size: 48px;\n  line-height: 1.2;\n  margin-bottom: 12px;\n}\n\n.registration-hero .accent {\n  color: #ff6b35;\n}\n\n.registration-hero p {\n  color: #b3b3b3;\n  max-width: 820px;\n  margin: 8px auto 0;\n  line-height: 32px;\n}\n\n.registration-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 18px;\n}\n\n.reg-card {\n  background: linear-gradient(0deg, #1c1b26, #1c1b26),\n    linear-gradient(180deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0) 100%);\n  border: 3px solid rgba(75, 75, 75, 0.25);\n  border-radius: 16px;\n  padding: 18px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  transition: transform 0.2s ease, box-shadow 0.25s ease, border-color 0.25s ease;\n}\n\n.reg-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 14px 30px rgba(251, 133, 0, 0.15);\n  border-color: rgba(251, 133, 0, 0.35);\n}\n\n.reg-card__head h2 {\n  font-family: Eczar, serif;\n  font-size: 24px;\n  margin-bottom: 4px;\n}\n\n.reg-card__head p {\n  color: #b3b3b3;\n  line-height: 28px;\n}\n\n.reg-card__list {\n  margin: 10px 0 12px;\n  padding-left: 18px;\n  color: #d6d6d6;\n}\n\n.reg-card__list li {\n  margin: 6px 0;\n}\n\n.reg-card__cta {\n  margin-top: 8px;\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  text-decoration: none;\n  color: #0b0b0f;\n  font-weight: 600;\n  font-family: Inter, sans-serif;\n  border-radius: 14px;\n  min-height: 48px;\n  padding: 0 18px;\n}\n\n.btn--primary {\n  background: linear-gradient(90deg, #ff6b35, #fb8500);\n  box-shadow: 0 10px 24px rgba(251, 133, 0, 0.25);\n  transition: transform 0.15s ease, box-shadow 0.2s ease, filter 0.2s ease;\n}\n\n.btn--primary:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 14px 30px rgba(251, 133, 0, 0.35);\n  filter: saturate(1.05);\n}\n\n.btn--primary:active {\n  transform: translateY(0);\n  box-shadow: 0 6px 14px rgba(251, 133, 0, 0.25);\n}\n\n.btn__icon {\n  font-size: 18px;\n}\n\n.registration-note {\n  margin-top: 18px;\n  text-align: center;\n}\n\n.registration-note p {\n  color: #9f9f9f;\n}\n\n/* Responsiveness */\n@media screen and (max-width: 768px) {\n  .registration-hero h1 {\n    font-size: 36px;\n  }\n}\n\n@media screen and (max-width: 576px) {\n  .registration-hero {\n    margin-top: 84px;\n  }\n  .registration-hero h1 {\n    font-size: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
